export class ConvenioModel {
    id: number;
    empresaId: number;
    tipoAtributo: string;
    atributo: string;
    convenioId: number;
    salarioBruto: number;
  }
  